// Legacy jQuery ./components w/ on ready hooks
window.Reverb.Forms = require('components/forms.js');
const CheckoutTotals = require('components/bundled_checkout/checkout_totals.js');
require('components/set_ajax_meta_tags.js');
require('components/products_show.js');
require('components/products_view.js');
require('components/reverb.attachinary.js');
require('components/attachinary_fields.js');
require('components/detector/trade.js');
require('components/detector/layaway.js');
const ShopPolicies = require('components/shop_policies.js');
require('components/credit_cards/input_mask.js');
require('components/credit_cards/card_type.js');
require('components/dashboard/index.js');
require('components/legacy/mobile_web_image_zoom.js');
require('components/legacy/plugins/jquery.check-all.js');
require('components/legacy/plugins/jquery.click-off-close.js');
require('components/legacy/plugins/jquery.price-mask.js');
require('components/legacy/plugins/jquery.spin.js');
require('components/legacy/typeahead.js');
require('components/legacy/jquery.onanimate.js');
require('components/legacy/jquery.focusFirstInput.js');
require('components/legacy/jquery.simple-method.js');
require('components/legacy/address.js');
require('components/legacy/animations.js');
window.Tabs = require('components/legacy/nav-tabs.js');
require('components/legacy/image-gallery.js');
require('components/legacy/badges.js');
require('components/legacy/user_activity.js');
require('components/legacy/paypal_profile.js');
require('components/legacy/autosubmit.js');
require('components/legacy/remote_tooltip.js');
require('components/legacy/remote_checkbox.js');
require('components/legacy/readmore.js');
require('components/legacy/character_limit.js');
require('components/legacy/numbers.js');
require('components/legacy/tax_forms.js');
require('components/legacy/sticky_header.js');
require('components/legacy/cart.js');
require('components/legacy/ajax_pagination.js');
require('components/legacy/block_seller_action.js');
require('components/legacy/order_totaler.js');
require('components/legacy/s3_uploader.js');
require('components/legacy/currency_exchange.js');
require('components/legacy/video.js');
require('components/legacy/responsive-menu.js');
require('components/legacy/open_lightbox_on_load.js');
require('components/legacy/raty.js');

// bundled checkout (TODO: still used?)
require('components/legacy/bundled_checkout/toggle_form');
require('components/legacy/bundled_checkout/credit_card');
require('components/legacy/bundled_checkout/discount_codes');

// dashboard
require('components/legacy/dashboard/feedback');
require('components/legacy/dashboard/messages')
require('components/legacy/dashboard/messages/toggle_read_status')
require('components/legacy/dashboard/refund_request_adjustment');
require('components/legacy/dashboard/selling/billing')
require('components/legacy/dashboard/selling/bulk_bump')
require('components/legacy/dashboard/selling/delete_draft');
require('components/legacy/dashboard/selling/refund_requests');
require('components/legacy/dashboard/selling/seller_sales')
require('components/legacy/dashboard/selling/shipping_labels')
require('components/legacy/dashboard/shop')
require('components/legacy/dashboard/submit_offer_lightbox')

// offers
require('components/legacy/offers/inline_offer');
require('components/legacy/offers/collect_location');

// listing
require('components/legacy/listing/general.js');
require('components/legacy/listing/inventory.js');
require('components/legacy/listing/shipping_validation.js');
require('components/legacy/listing/add_shipping_rate.js');
require('components/legacy/listing/payment_method_validation.js');
require('components/legacy/listing/caps_detector.js');
require('components/legacy/listing/soundcloud.js');
require('components/legacy/listing/product_type_change.js');

// shipping
require('components/legacy/shipping/estimator.js');
require('components/legacy/shipping/shipping_profile_select.js');

// init
require('components/legacy/init/chosen.js');
require('components/legacy/init/blankshield.js');
require('components/legacy/init/hoverIntent.js');
require('components/legacy/init/datepicker.js');
require('components/legacy/init/owl-carousel.js');
require('components/legacy/init/powertip.js');
require('components/legacy/init/autocomplete.js');
require('components/legacy/init/ajaxCSRF.js');
require('components/legacy/init/temporal.js');

// dom
require('components/legacy/dom/dom-patterns.js');
require('components/legacy/dom/remove.js');
require('components/legacy/dom/remove-parent.js');
require('components/legacy/dom/disclosure-toggle.js');
require('components/legacy/dom/smooth_scrolling.js');
require('components/legacy/dom/store-checkbox.js');
require('components/legacy/dom/delay-submit.js');
require('components/legacy/highlight.js');
require('components/legacy/html5_validation.js');
require('components/legacy/link_to_back.js');
require('components/legacy/ajax_load_and_replace.js');
require('components/legacy/ajax_fetch_on_page_load.js');

// mobile
require('components/legacy/mobile/tooltips.js');
require('components/legacy/mobile/menu.js');

// image_attachment
require('components/legacy/better_dragdrop');


const BumpRemoteReservations = require('components/dashboard/selling/bump/remote_reservations.js');

// auctions
const AuctionBidAmountChecker = require('components/legacy/auctions/bid_amount_checker.js');
const AuctionBidPlacement = require('components/legacy/auctions/bid_placement.js');
const AuctionCountdown = require('components/legacy/auctions/countdown.js');
const AuctionCreate = require('components/legacy/auctions/create.js');

window.Reverb.Auctions = window.Reverb.Auctions || {};
window.Reverb.Auctions.BidResponseHandler = require('components/legacy/auctions/bid_response_handler.js');

const BumpShopStats = require('components/legacy/bump/shop_stats.js');
const AdminBump = require('components/legacy/admin/bump.js');
const GiftCardRedeem = require('components/legacy/gift_cards/redeem.js');
const GiftCardAccountForm = require('components/legacy/gift_cards/create_account_form.js');
const WishList = require('components/legacy/wish_list.js');
const NagAlerts = require('components/legacy/nag_alerts.js');
const Panels = require('components/legacy/panels.js');
const SalesManagement = require('components/legacy/sellers/sales_management.js');
const FeedbackTips = require('components/legacy/feedback_tips.js');
const StartChat = require('components/legacy/start_chat.js');
const NewsletterSamples = require('components/legacy/newsletter_samples.js');
window.Reverb.YoutubeAPI = require('components/legacy/youtube_api.js');
const Messages = require('components/legacy/messages.js');
const ReverbOffers = require('components/legacy/reverb_offers.js');
const TrackInteraction = require('components/shared/track_interaction.js');
const ShippingLabelRatesForm = require('components/legacy/shipping_labels/rates_form');

window.addEventListener('DOMContentLoaded', () => {
  AuctionBidAmountChecker.init();
  AuctionBidPlacement.init();
  AuctionCountdown.init();
  AuctionCreate.init();
  BumpShopStats.init();
  AdminBump.init();
  GiftCardRedeem.init();
  GiftCardAccountForm.init();
  CheckoutTotals.init();
  ShopPolicies.init();
  BumpRemoteReservations.init();
  WishList.init();
  NagAlerts.init();
  Panels.init();
  SalesManagement.init();
  FeedbackTips.init();
  StartChat.init();
  NewsletterSamples.init();
  Messages.init();
  ReverbOffers.init();
  TrackInteraction.init();
  ShippingLabelRatesForm.init();
});



// WEBPACK FOOTER //
// ./javascripts/components/legacy.js